if (typeof whySection !== 'function') {
    class whySection extends HTMLElement {
        constructor() {
            super();
            this.accordionTriggers = this.querySelectorAll('[data-accordion-header-for]');
            this.accordionContents = this.querySelectorAll('[data-accordion-content-for]');
            this.initAccordion();
            this.section = null;
        }

        initAccordion() {
            this.accordionTriggers.forEach(trigger => {
                trigger.addEventListener("click", (event) => {
                    const targetId = trigger.getAttribute("data-accordion-header-for");
                    const targetContent = this.querySelector(`[data-accordion-content-for='${targetId}']`);
                    let paddingContent = 25;

                    if (!targetContent) return;

                    // Guardar si ya está activo antes de cerrar todo
                    const wasActive = trigger.classList.contains("active");

                    // Cerrar todas las secciones
                    this.accordionTriggers.forEach(item => item.classList.remove("active"));
                    this.accordionContents.forEach(content => {
                        content.style.maxHeight = null;
                        content.setAttribute("aria-hidden", "true");
                    });

                    // Si no estaba activo, lo activamos
                    if (!wasActive) {
                        trigger.classList.add("active");
                        targetContent.style.maxHeight = (targetContent.scrollHeight + paddingContent) + "px";
                        targetContent.setAttribute("aria-hidden", "false");
                    }
                });
            });
        }

        connectedCallback() {
            this.section = this.querySelector('[data-section]');
            if (this.section) {
                this.observeSection();
            }
        }

        observeSection() {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.section.classList.add('show');
                    } else {
                        this.section.classList.remove('show');
                    }
                });
            }, { threshold: 0.6 });

            observer.observe(this.section);
        }
    }

    if (typeof customElements.get('adrnl-why-section') === 'undefined') {
        customElements.define('adrnl-why-section', whySection);
    }
}
